export default __webpack_public_path__ + "static/media/dot.a8c48963.svg";